/* eslint-disable */
import { genericService } from '../_utilities/generic';
import api from '../_api';

const genericInvitationsService = (pathname) => ({
  getAppointmentInvitations(payload) {
    return api.get(`/${pathname}/fetch/`, { params: payload });
  },
  getAppointmentInvitationsActivity(payload) {
    return api.get(`/${pathname}/appointment_activity/`, { params: payload });
  },
  createInvites(payload) {
    return api.post(`/${pathname}/`, payload);
  },
  getActivityEvents(id) {
    return api.get(`/${pathname}/${id}/events/`)
  },
  ...genericService(pathname),
});

export default genericInvitationsService;
